<p-menu [model]="items()" styleClass="bg-surface-overlay w-full h-full" class="p-8">
  <ng-template pTemplate="item" let-item>
    @if (item.route) {
      <a [routerLink]="item.route" class="p-menuitem-link">
          <span [class]="item.icon"></span>
          <span class="ml-2">{{ item.label }}</span>
      </a>
    } @else {
      <a class="p-menuitem-link" [routerLink]="item.routerLink">
          <span [class]="item.icon"></span>
          <span class="ml-2">{{ item.label }}</span>
      </a>
    }
  </ng-template>
</p-menu>
